/* GASSISA
=========================================================================================
* Descripción: Módulo de entradas de inventario por Almacén o Exhibidor
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
 *      1       | 28/11/2025 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 13/08/2026 | Lic. José Luis Aragón Cervantes  | Lista completa y foco a nuevo registro
 *      4       | 30/08/2026 | Lic. José Luis Aragón Cervantes  | Alt+F12 elimina todo con confirmación
 * ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import Autocomplete from "../ui/Autocomplete";
import { Fragment, useEffect, useRef, useState } from 'react'
import { Alert } from "@mui/material";

import { defaultTypes } from "../../settings/enums.js";
import { getDateString, getDaeStringV2 } from "../../settings/utils.js"
import { apiFiltroExistenciasAlmacenExhibidor } from "../../settings/ApiConfig.js"

import CancelIcon from '@mui/icons-material/Cancel';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from '@mui/icons-material/Remove';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Tooltip, IconButton } from "@mui/material";

import SizeSoftXLectorCodigoBarrasGeneral from "../leyout/SizeSoftXLectorCodigoBarrasGeneral.jsx"
import SizeSoftXAlert from "../utils/SizeSoftXAlert.jsx"
import SizeSoftXLayoutForm from "../leyout/SizeSoftXLayoutForm.jsx"
import SemaforoStatus from "../utils/SemaforoStatus.jsx"
import SizeSoftXLoadingProcess  from "../../components/leyout/SizeSoftXLoadingProcess.jsx"
import ModalFirmaVentas from '../../components/ventas/ModalFirmarVentas.jsx'
import SizeSoftXConfirmDialog from "../leyout/SizeSoftXConfirmDialog.jsx";

import { useRequest } from "../../context/System/RequestContext.js";
import { useSesion } from "../../context/System/SesionContext.js";
import { useInventarios } from "../../context/Inventarios/InventariosContext.js";
import { useLayout } from "../../context/System/LayoutContext.js"
import { useFormTabLock } from "../../hooks/useFormTabLock.js";
import SizeSoftXTableEtiquetado from '../leyout/SizeSoftXTableEtiquetado.jsx';
import MnuEtiquetadoActions from './MnuEtiquetadoActions.jsx';
import CardEstatusImpresoraEtiquetado from './CardEstatusImpresoraEtiquetado.jsx';
import ModalBuscarArticulosEtiquetado from './ModalBuscarArticulosEtiquetado.jsx';
import ModalVistaPreviaEtiqueta from './ModalVistaPreviaEtiqueta.jsx';

export default function FrmEtiquetado() {
    const { isLocked: isFormLocked } = useFormTabLock('etiquetado', {
        title: 'Etiquetado',
        onLockDetected: (info) => {
            console.warn(`El formulario de ${info?.title || 'Etiquetado'} ya está abierto en otra pestaña`);
        }
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (isFormLocked) {
            alert("El formulario de Etiquetado ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.");
            setTimeout(() => {
                handleClickRegresarMainDashboard();
            }, 900);
        }
    }, [isFormLocked]);

    const {
        listaAlmacenesExhibidoresGeneral,
        handleObtenerAlmacenesExhibidores,
        dataFiltroExistencias,
        statusWaiting, setStatusWaiting,
        handleClickRegresarMainDashboard,
        dataArticuloEtiquetar,
        articuloEtiquetar,
        handleChangeRowEtiquetar,
        cantidadesEtiquetado,
        handleChangeCantidadEtiquetado,
        integrarInventario,
        handleGetListEtiqetado,
        almacenExhibidorEtiquetado, setAlmacenExhibidorEtiquetado,
        handleAgregarAEtiquetado,
        openModalFirmaTraslados,
        handleCerrarFirmaTraslados,
        handleEliminaPartidaEtiquetado,
        handleEliminaEtiquetadoCompleto,
        handleImprimirEtiquetas,
        statusEnableFieldsEtiquetado,
        openModalConfirmIntegrar,
        setOpenModalConfirmIntegrar,
        handleCloseModalConfirmIntegrar,
        handleConfirmIntegrarInventario,
        ejecutarImpresionYIntegracion,
        openModalConfirmSoloEtiquetado,
        setOpenModalConfirmSoloEtiquetado,
        handleConfirmSoloEtiquetado,
        handleCambiarAlmacenEtiquetado,
        estadoImpresoraEtiqueta,
        validarImpresoraEtiqueta,
        estadoPrinterTools,
        validarConexionPrinterTools,
        impresoraAlternativaEtiqueta,
        setImpresoraAlternativaEtiqueta,
        listaImpresorasEtiqueta,
        cargarListaImpresorasEtiqueta,
    } = useInventarios();

    const [medida,setMedida]=useState(0);
    const [medidaEtiqueta,setMedidaEtiqueta]=useState(0);
    const [openModalArticulos, setOpenModalArticulos] = useState(false);
    const [openConfirmEliminarTodo, setOpenConfirmEliminarTodo] = useState(false);
    const tablaEtiquetadoRef = useRef(null);
    const ultimoArticuloAgregadoRef = useRef("");
    const [openModalVistaPrevia, setOpenModalVistaPrevia] = useState(false);
    const [lineaVistaPrevia, setLineaVistaPrevia] = useState(null);

    const {parametrosCajaForm, handleObtenerParametrosCaja} = useSesion();

    const { GetRequest, PostRequest } = useRequest()

    const { handleOpenAlert } = useLayout()

    const [printerToolsBlocked, setPrinterToolsBlocked] = useState(false)

    const handleRevalidarEstatusImpresion = async () => {
        const enLinea = await validarConexionPrinterTools(true);
        setPrinterToolsBlocked(!enLinea);
        if (enLinea) {
            await validarImpresoraEtiqueta(true);
        }
    };

    const getStoredAlmacen = () => {
        try {
            return localStorage.getItem('etiquetado_almacenExhibidor') || "";
        } catch { return ""; }
    };

    const [almacenexhibidor, setAlmacenExhibidor] = useState(getStoredAlmacen);
    const [totalEtiquetas, setTotalEtiquetas] = useState(0);
    const [cantidadArticulos, setCantidadArticulos] = useState(0);

    const getTotalEtiquetasIntegrar = () => {
        let total = 0;
        Object.values(cantidadesEtiquetado || {}).forEach((tallas) => {
            Object.values(tallas || {}).forEach((cantidad) => {
                total += Number(cantidad) || 0;
            });
        });
        return total;
    };

    const handleChangeAlmacenexhibidor = async (e, newDat) => {
        const nuevoAlmacen = typeof newDat === "string" ? newDat : newDat?.nombre;
        if (!nuevoAlmacen) return;

        const tieneArticulos = dataArticuloEtiquetar && dataArticuloEtiquetar.length > 0;

        if (tieneArticulos) {
            if (!window.confirm("Hay artículos cargados. ¿Desea recargar la lista de artículos para el nuevo almacén/exhibidor?")) {
                setAlmacenExhibidor(nuevoAlmacen);
                setAlmacenExhibidorEtiquetado(nuevoAlmacen);
                return;
            }

            setStatusWaiting(true);

            const resultado = await handleCambiarAlmacenEtiquetado(nuevoAlmacen, almacenexhibidor);

            if (!resultado) {
                setStatusWaiting(false);
                return;
            }

            setAlmacenExhibidor(nuevoAlmacen);
            setAlmacenExhibidorEtiquetado(nuevoAlmacen);
            await handleGetListEtiqetado(nuevoAlmacen);
            setStatusWaiting(false);
        } else {
            setAlmacenExhibidor(nuevoAlmacen);
            setAlmacenExhibidorEtiquetado(nuevoAlmacen);
            setStatusWaiting(true);
            await handleGetListEtiqetado(nuevoAlmacen);
            setStatusWaiting(false);
        }
    };

    const handleBuscarArticulo = async (e) => {
        if (!almacenexhibidor) return;
        setStatusWaiting(true);
        const response = await PostRequest({
            url: apiFiltroExistenciasAlmacenExhibidor,
            body: { filtro: e.descripcion?.trim(), almacenexhibidor: almacenexhibidor.trim() },
            loader: "Buscando artículo por código de barras..."
        });
        setStatusWaiting(false);
        if (response.HasError) {
            handleOpenAlert(response.message || "Error al buscar artículo");
            return;
        }
        const data = response?.result || [];
        if (data.length > 0) {
            ultimoArticuloAgregadoRef.current = (data[0]?.clavearticulo || "").trim();
            await handleAgregarAEtiquetado(data[0]);
            handleOpenAlert("Artículo agregado al etiquetado", "OK");
        } else {
            handleOpenAlert("No se encontró el artículo", "error");
        }
    };

    const handleArticuloSeleccionado = async (articulo) => {
        ultimoArticuloAgregadoRef.current = (articulo?.clavearticulo || "").trim();
        await handleAgregarAEtiquetado(articulo);
    };

    const handleFirmarTraslados=async()=>{
        if (!listaTrasladosData) return;
        await handleImprimirTrasladoCaja();
        await handleImprimirTraslado(parametrosCajaForm.caja.trim());
        await handleAplicarTrasladoPC(null, parametrosCajaForm.caja.trim());
    };

    useEffect(() => {
        const init = async () => {
            await handleObtenerParametrosCaja()
            const enLinea = await validarConexionPrinterTools(true)
            if (!enLinea) {
                setPrinterToolsBlocked(true)
                handleOpenAlert("PrinterTools no habilitado para etiquetar: agente local no responde", "error")
                return
            }
            await validarImpresoraEtiqueta(false)
            await cargarListaImpresorasEtiqueta()
            if (listaAlmacenesExhibidoresGeneral.length === 0) {
                handleObtenerAlmacenesExhibidores("GENERAL")
            }
            if (dataArticuloEtiquetar.length === 0) {
                handleGetListEtiqetado()
            }
        }
        init()
    }, [])

    // Impresora efectiva: alternativa (si se capturó) o la predeterminada.
    // Al limpiarla se regresa a la predeterminada sin perder la captura.
    const nombreImpresoraConfigurada = (parametrosCajaForm?.nombreimpresoraetiqueta || "").trim();
    const impresoraEfectiva = (impresoraAlternativaEtiqueta || "").trim() || nombreImpresoraConfigurada;
    useEffect(() => {
        if (printerToolsBlocked) return;
        if (!impresoraEfectiva) return;
        validarImpresoraEtiqueta(false, impresoraEfectiva);
    }, [impresoraEfectiva]);

    const handleChangeImpresoraAlternativa = (_, v) => {
        const nombre = (typeof v === "string" ? v : (v?.name || "")).trim();
        setImpresoraAlternativaEtiqueta(nombre);
        // Validación inmediata de la impresora elegida (sin esperar al efecto).
        if (!printerToolsBlocked) {
            validarImpresoraEtiqueta(false, nombre || nombreImpresoraConfigurada);
        }
    };

    //Listas ordenadas para combos selectores    
    const listaAlmacenesExhibidoresOrdenada = listaAlmacenesExhibidoresGeneral?.slice().sort((c, d) => c.almacenexhibidor.localeCompare(d.almacenexhibidor));
    
    let listaAlmacenesExhibidoresAutoComplete = [];
    listaAlmacenesExhibidoresOrdenada?.map((y) =>
        listaAlmacenesExhibidoresAutoComplete.push({
            id: y.id,
            nombre: y.almacenexhibidor,
        })
    );

    const handleSelectInputText = (e) => {
        e.stopPropagation();   // 🔥 evita que la tabla capture el click
        e.target.select();     // selecciona SOLO el texto del input
    };

    //Key actions windows
    useEffect(() => {
        const handleKeyDown =async (event) => {
            if (event.key.trim().toUpperCase() === 'F4') {
                event.preventDefault();
                event.stopPropagation();
                handleClickRegresarMainDashboard();
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'F1') {
                event.preventDefault();
                event.stopPropagation();
                setOpenModalArticulos(true);
             }

             if (event.altKey && event.key.trim().toUpperCase() === 'I') {
                if (!dataArticuloEtiquetar || dataArticuloEtiquetar.length === 0) return;
                event.preventDefault();
                event.stopPropagation();
                setOpenModalConfirmIntegrar(true);
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'F7') {
                if (!dataArticuloEtiquetar || dataArticuloEtiquetar.length === 0) return;
                event.preventDefault();
                event.stopPropagation();
                await handleEliminaPartidaEtiquetado(articuloEtiquetar);
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'F12') {
                if (!dataArticuloEtiquetar || dataArticuloEtiquetar.length === 0) return;
                event.preventDefault();
                event.stopPropagation();
                setOpenConfirmEliminarTodo(true);
            }

        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [dataArticuloEtiquetar, articuloEtiquetar]);
    useEffect(() => {
        const claveAgregada = (ultimoArticuloAgregadoRef.current || "").trim();
        if (!claveAgregada || !Array.isArray(dataArticuloEtiquetar) || dataArticuloEtiquetar.length === 0) return;

        const articuloAgregado = dataArticuloEtiquetar.find((articulo) =>
            (articulo?.clavearticulo || "").trim() === claveAgregada
        );
        if (!articuloAgregado) return;

        handleChangeRowEtiquetar(articuloAgregado);

        setTimeout(() => {
            const container = tablaEtiquetadoRef.current;
            if (!container) return;

            const rows = container.querySelectorAll("tr[data-row-id]");
            const rowNueva = Array.from(rows).find((row) => row.getAttribute("data-row-id") === articuloAgregado.id);
            if (!rowNueva) return;

            rowNueva.scrollIntoView({ behavior: "smooth", block: "center" });
            rowNueva.focus({ preventScroll: true });
        }, 120);

        ultimoArticuloAgregadoRef.current = "";
    }, [dataArticuloEtiquetar, handleChangeRowEtiquetar]);
    
    useEffect(() => {
        // 1) Total de artículos en la tabla de etiquetado
        setCantidadArticulos(dataArticuloEtiquetar?.length ?? 0);

        // 2) Total de etiquetas = suma de todas las cantidades capturadas
        const total = Object.values(cantidadesEtiquetado || {}).reduce((accArt, tallas) => {
            const subtotal = Object.values(tallas || {}).reduce((accMed, cantidad) => {
                return accMed + (Number(cantidad) || 0);
            }, 0);
            return accArt + subtotal;
        }, 0);

        setTotalEtiquetas(total);
    }, [dataArticuloEtiquetar, cantidadesEtiquetado]);

    const handleOpenVistaPrevia = () => {
        const articulos = dataArticuloEtiquetar || [];
        const cantidades = cantidadesEtiquetado || {};

        for (const articulo of articulos) {
            const id = articulo.id;
            const tallas = cantidades[id];
            if (!tallas) continue;
            const medidas = articulo.listamedidas || [];
            for (const medidaObj of medidas) {
                const medidaKey = String(medidaObj.medida);
                const total = Number(tallas[medidaKey]) || 0;
                if (total > 0) {
                    setLineaVistaPrevia({
                        clavearticulo: articulo.clavearticulo || "",
                        descripcionArticulo: articulo.descripcion || "",
                        medida: medidaKey,
                        totalEtiquetas: total,
                        codigoBarras: medidaObj?.codigobarras || "",
                    });
                    setOpenModalVistaPrevia(true);
                    return;
                }
            }
        }
        handleOpenAlert("No hay etiquetas con cantidades asignadas para previsualizar", "warning");
    };

    const handleRefresh = async () => {
        setStatusWaiting(true);
        await handleGetListEtiqetado(almacenexhibidor);
        setStatusWaiting(false);
    };

    return(
        <>
            <Fragment>
                <SizeSoftXLayoutForm
                    titlePage="Modulo de Etiquetado"
                    buttonActions={<><MnuEtiquetadoActions onRefresh={handleRefresh} onBuscarArticulos={() => setOpenModalArticulos(true)} /><Tooltip title={"Vista previa de etiqueta"}>
                        <span>
                            <IconButton onClick={handleOpenVistaPrevia} disabled={!dataArticuloEtiquetar || dataArticuloEtiquetar.length === 0}>
                                <VisibilityIcon className="icon" /><p className="icon">Vista previa</p>
                            </IconButton>
                        </span>
                    </Tooltip></>}
                >
                <div className="conteiner-form-general">
                    <div className="body-form-etiquetado">
                        <div className = "filtro-Etiquetado">
                            <Autocomplete
                                freeSolo
                                noOptionsText={"Sin resultados"}
                                disableClearable
                                id={"id"}
                                name={"AlmacenExhibidor"}
                                options={listaAlmacenesExhibidoresAutoComplete}
                                getOptionLabel={(option) => typeof option === "string" ? option : option.nombre}
                                value={listaAlmacenesExhibidoresAutoComplete.find(x => x.nombre === almacenexhibidor) || almacenexhibidor}
                                onChange={(e, newDat) => handleChangeAlmacenexhibidor(e, newDat)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Almacén o Exhibidor:" required />
                                )}
                                sx={{ width: '300px', height: '6.3vh'}}
                                disabled={statusEnableFieldsEtiquetado || printerToolsBlocked}
                            />
                            <div className='codigobarrasetiquetado'>
                                <SizeSoftXLectorCodigoBarrasGeneral
                                    statusBotonCarga={false}
                                    handleRegistrarArticulo = {handleBuscarArticulo}
                                    disabled={statusEnableFieldsEtiquetado || printerToolsBlocked}
                                /> 
                            </div>
                        </div>
                        {printerToolsBlocked && (
                            <Alert severity="warning" sx={{ mb: 1, mt: 1 }}>
                                <strong>Printer Tools no disponible</strong> — La estación de etiquetado no esté operativa. Los buscadores de artículos se han deshabilitado para evitar registros con datos inconsistentes.
                            </Alert>
                        )}
                        <CardEstatusImpresoraEtiquetado
                            estadoPrinterTools={estadoPrinterTools}
                            estadoImpresora={estadoImpresoraEtiqueta}
                            onReintentar={handleRevalidarEstatusImpresion}
                            verificando={estadoPrinterTools.verificando}
                            esAlternativa={!!(impresoraAlternativaEtiqueta || "").trim()}
                        />
                        {!printerToolsBlocked && (
                            <Autocomplete
                                freeSolo
                                clearOnEscape
                                options={listaImpresorasEtiqueta}
                                getOptionLabel={(o) => typeof o === "string" ? o : (o?.name || "")}
                                value={listaImpresorasEtiqueta.find((x) => x.name === (impresoraAlternativaEtiqueta || "").trim()) || (impresoraAlternativaEtiqueta || "")}
                                onChange={handleChangeImpresoraAlternativa}
                                isOptionEqualToValue={(o, v) => (typeof o === "string" ? o : o?.name) === (typeof v === "string" ? v : v?.name)}
                                disabled={estadoPrinterTools.verificando}
                                renderOption={(props, o) => (
                                    <li {...props} key={o.name}>
                                        <span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', backgroundColor: o.canPrint ? '#2E7D32' : '#D32F2F' }} />
                                        <span style={{ marginLeft: 8 }}>{o.name}</span>
                                        <span style={{ marginLeft: 8, color: '#888', fontSize: '0.75rem' }}>{o.statusCode}</span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Impresora alternativa (opcional)"
                                        size="small"
                                        helperText={(impresoraAlternativaEtiqueta || "").trim()
                                            ? "Se usaré esta impresora. Límpiala para volver a la predeterminada."
                                            : `Vacía = predeterminada (${nombreImpresoraConfigurada || "sin configurar"}).`}
                                    />
                                )}
                                sx={{ width: '300px', mb: 1 }}
                            />
                        )}
                        <div className='container-tablas-etiquetado'>
                            <div className="tablas-etiquetado">
                                <SizeSoftXTableEtiquetado
                                    columns={[
                                        { title: "Clave artículo", field: "clavearticulo", hideSort: false},
                                        { title: "Descripción", field: "descripcion", hideSort: false },
                                    ]}
                                    data={dataArticuloEtiquetar == null ? [] : dataArticuloEtiquetar}
                                    id="id"
                                    row={articuloEtiquetar}
                                    setRow={handleChangeRowEtiquetar}
                                    fontSize="small"
                                    rowsPerPageIntro={6}
                                    disablePagination={true}
                                    tableContainerRef={tablaEtiquetadoRef}
                                    activaProgress={statusWaiting}
                                    setClave={() => {}} 
                                    setMedida={setMedidaEtiqueta}
                                    cantidades={cantidadesEtiquetado}
                                    onChangeCantidad={handleChangeCantidadEtiquetado}                                    
                                />
                            </div>
                        </div>
                        <div className = "container-tablas-etiquetado-cantidades">
                            <TextField autoComplete="off"
                                name="totalpares"
                                label="Cantidad de artículos:"
                                value={cantidadArticulos}
                                InputProps={{ readOnly: true }}
                                sx={{ width: '200px', height: '7.2vh' }}
                            />
                            <TextField autoComplete="off"
                                name="Cantidad etiquetas"
                                label="Cantidad de etiquetas:"
                                value={totalEtiquetas}
                                InputProps={{ readOnly: true }}
                                onClick={handleSelectInputText}
                                onFocus={handleSelectInputText}
                                sx={{ width: '200px', height: '7.2vh' }}
                            />
                        </div>
                    </div>
                </div>
                </SizeSoftXLayoutForm>
                <SizeSoftXLoadingProcess
                    open={statusWaiting} message="Procesando información, por favor espere..." 
                />
                <ModalFirmaVentas
                    openModalFirmaPreVentas={openModalFirmaTraslados}
                    handleCloseModalFirmaPreVentas={handleCerrarFirmaTraslados}
                    handleFirmarPreventa={handleFirmarTraslados}
                />
                <SizeSoftXConfirmDialog
                    open={openModalConfirmIntegrar}
                    title="Confirmar integración a inventarios"
                    message={`Se integrarén ${getTotalEtiquetasIntegrar()} etiquetas al inventario. ¿Desea continuar?`}
                    handleConfirmDialog={handleConfirmIntegrarInventario}
                    colorTitle="#e65100"
                />
                <SizeSoftXConfirmDialog
                    open={openModalConfirmSoloEtiquetado}
                    title="Confirmar solo etiquetado"
                    message={`Se imprimirén ${getTotalEtiquetasIntegrar()} etiquetas sin integrar al inventario. ¿Desea continuar?`}
                    handleConfirmDialog={handleConfirmSoloEtiquetado}
                    colorTitle="#1565c0"
                />
                <SizeSoftXConfirmDialog
                    open={openConfirmEliminarTodo}
                    title="Eliminar todo"
                    message="¿Desea eliminar todo el etiquetado actual?"
                    handleConfirmDialog={(confirm) => {
                        setOpenConfirmEliminarTodo(false);
                        if (confirm) handleEliminaEtiquetadoCompleto();
                    }}
                    colorTitle="#e65100"
                />
                <ModalBuscarArticulosEtiquetado
                    openModal={openModalArticulos}
                    handleCloseModal={() => setOpenModalArticulos(false)}
                    almacenexhibidor={almacenexhibidor}
                    onArticuloSelect={handleArticuloSeleccionado}
                />
                <ModalVistaPreviaEtiqueta
                    open={openModalVistaPrevia}
                    onClose={() => setOpenModalVistaPrevia(false)}
                    lineaEtiqueta={lineaVistaPrevia}
                />
                <SizeSoftXAlert/>                
            </Fragment>
        </>
    )
}
